// Copyright text placeholder, Warner Bros. Discovery, Inc.

/**
 *  WARNING:
 *  This file is auto-generated. Do not edit manually. Any changes made to this
 *  file will be overwritten the next time it is generated. If you need to make
 *  changes, please modify the source files and re-generate this file.
 */

import { BaseEvent, IVersionedEvent } from '../../../core';

/**
 * An string enum prop which you can populate for testing purposes.
 * @public
 * @readonly
 */

enum TestEventEnumV2 {
  /** TestEventEnum of A **/
  A = 'A',
  /** TestEventEnum of B **/
  B = 'B',
  /** TestEventEnum of C **/
  C = 'C'
}
/**
 * An string enum prop which you can populate for testing purposes.
 * @public
 * @readonly
 */

enum AnotherTestEnumV2 {
  /** AnotherTestEnum of B **/
  B = 'B',
  /** AnotherTestEnum of C **/
  C = 'C',
  /** AnotherTestEnum of D **/
  D = 'D'
}
/**
 * An string enum prop which you can populate for testing purposes.
 * @public
 * @readonly
 */

enum EnumWithDefaultV2 {
  /** EnumWithDefault of B **/
  B = 'B',
  /** EnumWithDefault of C **/
  C = 'C',
  /** EnumWithDefault of D **/
  D = 'D'
}

/**
 *
 *
 * version 2.1
 * @public
 */
interface INestedArrayV2 {
  /**  **/
  bar?: number;
  /**  **/
  foo?: string;
}

/**
 *
 *
 * version 2.1
 * @public
 */
interface INestedObjectV2 {
  /**  **/
  bar?: boolean;
  /**  **/
  foo?: string;
}

/**
 *
 *
 * version 2.1
 * @public
 */
interface ITestEventV2Payload {
  /** A string prop which you can populate for testing purposes. Has a default value and is marked required. **/
  bar?: string;
  /**  **/
  constString?: string;
  /** An string enum prop which you can populate for testing purposes. **/
  anotherTestEnum?: AnotherTestEnumV2;
  /**  **/
  arrayOfObjects?: INestedArrayV2[];
  /** A string prop which you can populate for testing purposes. Is optional, and was added as a minor version update. **/
  baz?: string;
  /** An string enum prop which you can populate for testing purposes. **/
  enumWithDefault?: EnumWithDefaultV2;
  /** A string prop which you can populate for testing purposes. **/
  foo?: string;
  /**  **/
  nestedObject?: INestedObjectV2;
  /** An array prop which you can populate for testing purposes. Is optional, and was added as a minor version update. **/
  qux?: string[];
  /** An string enum prop which you can populate for testing purposes. **/
  testEventEnum?: TestEventEnumV2;
  /**  **/
  testMaxLength?: string;
}

/**
 * TestTestEventV2 event
 * An event which can be used to test aspects of the Event Schemas repo and integrations of Standard Events.
 * @public
 */
export class TestTestEventV2 extends BaseEvent<ITestEventV2Payload> {
  /** unique event type **/
  public readonly eventType: string = 'beam.events.test.testevent_2.1';
  /** An string enum prop which you can populate for testing purposes. **/
  public static TEST_EVENT_ENUM: typeof TestEventEnumV2 = TestEventEnumV2;
  /** An string enum prop which you can populate for testing purposes. **/
  public static ANOTHER_TEST_ENUM: typeof AnotherTestEnumV2 = AnotherTestEnumV2;
  /** An string enum prop which you can populate for testing purposes. **/
  public static ENUM_WITH_DEFAULT: typeof EnumWithDefaultV2 = EnumWithDefaultV2;

  /**
   * overrides the default _build method to add default values for fields
   * @param payload - The payload for this event.
   * @returns IVersionedEvent<ITestEventV2Payload>
   */
  protected override _build(payload: ITestEventV2Payload): IVersionedEvent<ITestEventV2Payload> {
    return super._build({
      ...payload,
      bar: 'bar',
      constString: 'constantly consting',
      enumWithDefault: EnumWithDefaultV2.B
    });
  }
}

export { TestEventEnumV2 as TestTestEventV2TestEventEnum };
export { AnotherTestEnumV2 as TestTestEventV2AnotherTestEnum };
export { EnumWithDefaultV2 as TestTestEventV2EnumWithDefault };
export type { INestedArrayV2 as ITestTestEventV2NestedArray };
export type { INestedObjectV2 as ITestTestEventV2NestedObject };
export type { ITestEventV2Payload as ITestTestEventV2Payload };
